
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser'
export { Prisma }
export * as $Enums from './enums'
export * from './enums';
/**
 * Model User
 * 
 */
export type User = Prisma.UserModel
/**
 * Model UserMfaSettings
 * 
 */
export type UserMfaSettings = Prisma.UserMfaSettingsModel
/**
 * Model AvaturnUser
 * 
 */
export type AvaturnUser = Prisma.AvaturnUserModel
/**
 * Model UserWallet
 * 
 */
export type UserWallet = Prisma.UserWalletModel
/**
 * Model WalletChallenge
 * 
 */
export type WalletChallenge = Prisma.WalletChallengeModel
/**
 * Model PlayerTier
 * 
 */
export type PlayerTier = Prisma.PlayerTierModel
/**
 * Model TableTemplate
 * 
 */
export type TableTemplate = Prisma.TableTemplateModel
/**
 * Model RakeStructure
 * 
 */
export type RakeStructure = Prisma.RakeStructureModel
/**
 * Model Table
 * 
 */
export type Table = Prisma.TableModel
/**
 * Model OFCHandResult
 * 
 */
export type OFCHandResult = Prisma.OFCHandResultModel
/**
 * Model Seat
 * 
 */
export type Seat = Prisma.SeatModel
/**
 * Model Waitlist
 * 
 */
export type Waitlist = Prisma.WaitlistModel
/**
 * Model Kyc
 * 
 */
export type Kyc = Prisma.KycModel
/**
 * Model Sumsub
 * 
 */
export type Sumsub = Prisma.SumsubModel
/**
 * Model Session
 * 
 */
export type Session = Prisma.SessionModel
/**
 * Model PropSession
 * 
 */
export type PropSession = Prisma.PropSessionModel
/**
 * Model CollectedRake
 * 
 */
export type CollectedRake = Prisma.CollectedRakeModel
/**
 * Model GeneratedRake
 * 
 */
export type GeneratedRake = Prisma.GeneratedRakeModel
/**
 * Model GeneratedRakeAggregate
 * 
 */
export type GeneratedRakeAggregate = Prisma.GeneratedRakeAggregateModel
/**
 * Model GeneratedLeaderboardRakeAggregate
 * 
 */
export type GeneratedLeaderboardRakeAggregate = Prisma.GeneratedLeaderboardRakeAggregateModel
/**
 * Model DeckResult
 * 
 */
export type DeckResult = Prisma.DeckResultModel
/**
 * Model MutedPlayer
 * 
 */
export type MutedPlayer = Prisma.MutedPlayerModel
/**
 * Model Chat
 * 
 */
export type Chat = Prisma.ChatModel
/**
 * Model TableSettings
 * 
 */
export type TableSettings = Prisma.TableSettingsModel
/**
 * Model UserLobbyFilters
 * 
 */
export type UserLobbyFilters = Prisma.UserLobbyFiltersModel
/**
 * Model PlayerDisconnection
 * 
 */
export type PlayerDisconnection = Prisma.PlayerDisconnectionModel
/**
 * Model DeviceFingerprint
 * 
 */
export type DeviceFingerprint = Prisma.DeviceFingerprintModel
/**
 * Model RakeSharePayout
 * 
 */
export type RakeSharePayout = Prisma.RakeSharePayoutModel
/**
 * Model RakeSharePayoutAggregate
 * 
 */
export type RakeSharePayoutAggregate = Prisma.RakeSharePayoutAggregateModel
/**
 * Model RewardPayout
 * 
 */
export type RewardPayout = Prisma.RewardPayoutModel
/**
 * Model UserAgreement
 * 
 */
export type UserAgreement = Prisma.UserAgreementModel
/**
 * Model PlayerMute
 * 
 */
export type PlayerMute = Prisma.PlayerMuteModel
/**
 * Model PlayerBlock
 * 
 */
export type PlayerBlock = Prisma.PlayerBlockModel
/**
 * Model RakebackPayout
 * 
 */
export type RakebackPayout = Prisma.RakebackPayoutModel
/**
 * Model Transaction
 * 
 */
export type Transaction = Prisma.TransactionModel
/**
 * Model HandHistory
 * 
 */
export type HandHistory = Prisma.HandHistoryModel
/**
 * Model HandStateHistory
 * 
 */
export type HandStateHistory = Prisma.HandStateHistoryModel
/**
 * Model FriendRequest
 * 
 */
export type FriendRequest = Prisma.FriendRequestModel
/**
 * Model Friend
 * 
 */
export type Friend = Prisma.FriendModel
/**
 * Model PlayerProfile
 * 
 */
export type PlayerProfile = Prisma.PlayerProfileModel
/**
 * Model Note
 * 
 */
export type Note = Prisma.NoteModel
/**
 * Model InternalTokensDeals
 * 
 */
export type InternalTokensDeals = Prisma.InternalTokensDealsModel
/**
 * Model DepositWallets
 * 
 */
export type DepositWallets = Prisma.DepositWalletsModel
/**
 * Model Deposits
 * 
 */
export type Deposits = Prisma.DepositsModel
/**
 * Model DepositBonus
 * 
 */
export type DepositBonus = Prisma.DepositBonusModel
/**
 * Model UserDepositBonus
 * 
 */
export type UserDepositBonus = Prisma.UserDepositBonusModel
/**
 * Model PerformanceMetric
 * 
 */
export type PerformanceMetric = Prisma.PerformanceMetricModel
/**
 * Model WeeklyRakeSharePayout
 * 
 */
export type WeeklyRakeSharePayout = Prisma.WeeklyRakeSharePayoutModel
/**
 * Model WeeklyRakeStats
 * 
 */
export type WeeklyRakeStats = Prisma.WeeklyRakeStatsModel
/**
 * Model Leaderboard
 * 
 */
export type Leaderboard = Prisma.LeaderboardModel
/**
 * Model LeaderboardHistory
 * 
 */
export type LeaderboardHistory = Prisma.LeaderboardHistoryModel
/**
 * Model LeaderboardSchedule
 * 
 */
export type LeaderboardSchedule = Prisma.LeaderboardScheduleModel
/**
 * Model ReferralHistory
 * 
 */
export type ReferralHistory = Prisma.ReferralHistoryModel
/**
 * Model ReferralHistoryMigration
 * 
 */
export type ReferralHistoryMigration = Prisma.ReferralHistoryMigrationModel
/**
 * Model Region
 * 
 */
export type Region = Prisma.RegionModel
/**
 * Model Country
 * 
 */
export type Country = Prisma.CountryModel
/**
 * Model CountrySubdivision
 * 
 */
export type CountrySubdivision = Prisma.CountrySubdivisionModel
/**
 * Model AgentDeal
 * 
 */
export type AgentDeal = Prisma.AgentDealModel
/**
 * Model RegionCountry
 * 
 */
export type RegionCountry = Prisma.RegionCountryModel
/**
 * Model RegionSubdivision
 * 
 */
export type RegionSubdivision = Prisma.RegionSubdivisionModel
/**
 * Model AgentDealUpdateRequest
 * 
 */
export type AgentDealUpdateRequest = Prisma.AgentDealUpdateRequestModel
/**
 * Model AgentAssociationMigrationBatch
 * 
 */
export type AgentAssociationMigrationBatch = Prisma.AgentAssociationMigrationBatchModel
/**
 * Model AgentAssociationMigrationUser
 * 
 */
export type AgentAssociationMigrationUser = Prisma.AgentAssociationMigrationUserModel
/**
 * Model ReferralRakeShareAggregate
 * 
 */
export type ReferralRakeShareAggregate = Prisma.ReferralRakeShareAggregateModel
/**
 * Model ReferralRakeShareMigration
 * 
 */
export type ReferralRakeShareMigration = Prisma.ReferralRakeShareMigrationModel
/**
 * Model TournamentTicketTemplate
 * 
 */
export type TournamentTicketTemplate = Prisma.TournamentTicketTemplateModel
/**
 * Model TournamentTicket
 * 
 */
export type TournamentTicket = Prisma.TournamentTicketModel
/**
 * Model TournamentBlindStructure
 * 
 */
export type TournamentBlindStructure = Prisma.TournamentBlindStructureModel
/**
 * Model TournamentBlindLevel
 * 
 */
export type TournamentBlindLevel = Prisma.TournamentBlindLevelModel
/**
 * Model TournamentPayoutStructure
 * 
 */
export type TournamentPayoutStructure = Prisma.TournamentPayoutStructureModel
/**
 * Model TournamentPayoutBracket
 * 
 */
export type TournamentPayoutBracket = Prisma.TournamentPayoutBracketModel
/**
 * Model TournamentBlindStructureSnapshot
 * 
 */
export type TournamentBlindStructureSnapshot = Prisma.TournamentBlindStructureSnapshotModel
/**
 * Model TournamentBlindLevelSnapshot
 * 
 */
export type TournamentBlindLevelSnapshot = Prisma.TournamentBlindLevelSnapshotModel
/**
 * Model TournamentPayoutStructureSnapshot
 * 
 */
export type TournamentPayoutStructureSnapshot = Prisma.TournamentPayoutStructureSnapshotModel
/**
 * Model TournamentPayoutBracketSnapshot
 * 
 */
export type TournamentPayoutBracketSnapshot = Prisma.TournamentPayoutBracketSnapshotModel
/**
 * Model TournamentTemplate
 * 
 */
export type TournamentTemplate = Prisma.TournamentTemplateModel
/**
 * Model TournamentRecurringSchedule
 * 
 */
export type TournamentRecurringSchedule = Prisma.TournamentRecurringScheduleModel
/**
 * Model Tournament
 * 
 */
export type Tournament = Prisma.TournamentModel
/**
 * Model TournamentRegistration
 * 
 */
export type TournamentRegistration = Prisma.TournamentRegistrationModel
/**
 * Model TournamentTableAssignment
 * 
 */
export type TournamentTableAssignment = Prisma.TournamentTableAssignmentModel
/**
 * Model TournamentEvent
 * 
 */
export type TournamentEvent = Prisma.TournamentEventModel
/**
 * Model TournamentRebuyAddonLog
 * 
 */
export type TournamentRebuyAddonLog = Prisma.TournamentRebuyAddonLogModel
/**
 * Model TournamentPlayerMovement
 * 
 */
export type TournamentPlayerMovement = Prisma.TournamentPlayerMovementModel
/**
 * Model TournamentPayout
 * 
 */
export type TournamentPayout = Prisma.TournamentPayoutModel
/**
 * Model TournamentDollarLedger
 * 
 */
export type TournamentDollarLedger = Prisma.TournamentDollarLedgerModel
/**
 * Model TournamentRebalanceMetrics
 * 
 */
export type TournamentRebalanceMetrics = Prisma.TournamentRebalanceMetricsModel
/**
 * Model GlobalSettings
 * 
 */
export type GlobalSettings = Prisma.GlobalSettingsModel
/**
 * Model TournamentSettings
 * 
 */
export type TournamentSettings = Prisma.TournamentSettingsModel
